import { Component, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { ChangeControlCreateComponent } from '../change-control-create/change-control-create.component';
import { ElementdetailsService } from 'src/app/Service/elementdetails/elementdetails.service';
import { ICCNListInputModel, ICCNApproveInputModel, ICCNUpdateInputModel } from 'src/app/ViewModel/CCNModel';
import { CcnService } from 'src/app/Service/ccn/ccn.service';
import { CommonService } from 'src/app/Service/Common.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { CcnPrintComponent } from '../change-control-create/ccn-print-dialog/ccn-print/ccn-print.component';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';
@Component({
  selector: 'app-change-control',
  templateUrl: './change-control.component.html',
  styleUrls: ['./change-control.component.css']
})
export class ChangeControlComponent implements OnInit {
  @ViewChild('docGrid') docGrid: any;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  public forActionList: any[] = [];
  public approvedList: any[] = [];
  public rejectedList: any[] = [];
  public publishedList: any[] = [];
  public data: any[] = [];
  public ccnList: any[] = [];
  public searchList: any[] = [];
  public isSearch: any;
  selectedRootIndex = 3;
  public ccnTypeList: any[] = [];
  public ccnType: number = 40;
  pageSize = 15;
  LastViewingRecords = 30;
  LastViewingRecord: string = "30";
  noOfDays = [30, 60, 90, 'All'];
  enableFilter = false;
  enableFullscreen = false;
  memberId: number = 0;
  projectId!: number;
  groupId: number = 0;
  selectedTabIndex = 0;
  public viewTabs: any = [];
  public viewData: any[] = [];

  constructor(
    private dialog: MatDialog,
    private commonService: CommonService,
    private notificationService: NotificationService,
    private elementdetailsService: ElementdetailsService,
    private ccnService: CcnService,
    public restApiService: RestApiService
  ) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.bindCCNType();
  }

  getGridData() {
    if (this.selectedTabIndex != 0) {
      this.viewData = [];
      let tab: any = this.viewTabs[this.selectedTabIndex - 1];
      this.viewData.push({
        projectId: this.projectId,
        groupId: this.groupId,
        ccnId: tab.ccnId,
        revisionNo: tab.ccnRevNo
      });
    }
    if (this.searchList.length > 0) {
      this.ccnList = this.searchList;
      if (this.dataBinding != undefined)
        this.dataBinding.skip = 0;
    }
    else {
      this.approvedList = this.data.filter(doc => doc.ccnProgress == 'Approved');
      this.forActionList = this.data.filter(doc => doc.ccnProgress == 'For Action');
      this.rejectedList = this.data.filter(doc => doc.ccnProgress == 'Rejected');
      this.publishedList = this.data.filter(doc => doc.ccnProgress == 'Published');
      switch (this.selectedRootIndex) {
        case 0:
          this.ccnList = this.forActionList;
          break;
        case 1:
          this.ccnList = this.approvedList;
          break;
        case 2:
          this.ccnList = this.rejectedList;
          break;
        case 3:
          this.ccnList = this.publishedList;
          break;
        default:
          this.ccnList = this.data;
          break;
      }
      this.dataBinding.skip = 0;
    }
  }

  public lastviewingrecordsmethod(event: any) {
    if (event == "All") {
      this.LastViewingRecords = 0;
      this.refreshGrid();
      this.LastViewingRecord = "All";
    }
    else {
      this.LastViewingRecords = event;
      this.LastViewingRecord = event;
      this.refreshGrid();
    }
  }

  async bindCCNType() {

    let x = await this.elementdetailsService.GetElementDetailsByDescList('CCN Type').toPromise();
    if (x) {
      this.ccnTypeList = x
      this.ccnType = this.ccnTypeList[0].deD_Id.toString();
    }
    this.refreshGrid();
  }

  public changeControlNote() {
    let dialogRef = this.dialog.open(ChangeControlCreateComponent, {
      panelClass: ['mat-dialog-primary'],
      data: { ccnId: -1, ccnRevNo: 0, ccnType: this.ccnType }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }
  public tabClick(event: any) {
    this.docGrid.defaultSelection.selectedKeys = [];
    this.ccnList.forEach(x => x.isSelected = false);
    this.searchList = [];
    this.getGridData();
  }

  public onTypeChange(val: any) {
    this.searchList = [];
    this.ccnList.forEach(x => x.isSelected = false);
    this.ccnType = val.value;
    this.refreshGrid();
  }

  async refreshGrid() {
    let ccnInput: ICCNListInputModel = {
      projectId: this.projectId,
      cCType: this.ccnType,
      createdFromDays: this.LastViewingRecords
    };
    this.data = await this.ccnService.GetCCNList(ccnInput).toPromise();
    this.docGrid.defaultSelection.selectedKeys = [];
    this.data.forEach(x => x.isSelected = false);
    this.getGridData();
  }

  public showMessage(res: StandardOutputModel) {
    if (res.successCode == 200) {
      this.notificationService.showToast(res.successMessage, "Success");
    }
    else {
      this.notificationService.showToast(res.successMessage, "Warning");
    }
    this.refreshGrid();
  }

  async approveCCN(data: any, isApproved: boolean) {
    if (data.submitDate != null) {
      let inputModel: ICCNApproveInputModel = {
        cCNId: data.ccnId,
        cCNRevNo: data.ccnRevNo,
        userId: this.memberId,
        isApproved: isApproved
      };
      let res: StandardOutputModel = await this.ccnService.ApproveCCN(inputModel).toPromise();
      this.showMessage(res);
    }
    else {
      this.notificationService.showToast("CCN has not been submitted", "Warning")
    }
  }

  public approveAllCCN(isApproved: any) {
    let selectList = this.ccnList.filter(x => x.isSelected == true);
    let successMessage = '';
    if (selectList.length > 0) {
      let flag = selectList.findIndex(x => x.submitDate == null);
      if (flag != -1) {
        this.notificationService.showToast("Some documents are pending submission", "Warning");
        return;
      }
      selectList.forEach(async element => {
        if (element.submitDate != null) {
          let inputModel: ICCNApproveInputModel = {
            cCNId: element.ccnId,
            cCNRevNo: element.ccnRevNo,
            userId: this.memberId,
            isApproved: isApproved
          };
          let res: StandardOutputModel = await this.ccnService.ApproveCCN(inputModel).toPromise();
        }
      });
      if (successMessage != '') {
        this.notificationService.showToast(successMessage, "Warning");
      }
      else {
        let msg = isApproved ? "Records Updated Successfully" : "Records Rejected Successfully";
        this.notificationService.showToast(msg, "Success");
      }
      this.refreshGrid();
    }
    else {
      this.notificationService.showToast("Kindly select atleast one record", "Warning");
    }
  }

  async publishCCN(ccn: any) {
    if (ccn.submitDate != null && ccn.approveDate != null) {
      if (ccn.attachmentsCount <= 0) {
        this.notificationService.showToast("CCN proof has not been attached", "Warning")
        return;
      }
      let ccnInput: ICCNUpdateInputModel = {
        cCNId: ccn.ccnId,
        cCNRevNo: 0,
        userId: this.memberId
      }
      let res: StandardOutputModel = await this.ccnService.PublishCCN(ccnInput).toPromise();
      this.showMessage(res);
    }
    else {
      this.notificationService.showToast("CCN has not been approved", "Warning")
    }
  }

  async publishAllCCN() {
    let selectList = this.ccnList.filter(x => x.isSelected == true);
    let successMessage = '';
    if (selectList.length > 0) {
      let flag = selectList.findIndex(x => x.attachmentsCount <= 0);
      if (flag != -1) {
        this.notificationService.showToast("CCN proof has not been attached for some documents", "Warning")
        return;
      }
      flag = selectList.findIndex(x => x.submitDate == null && x.approveDate == null);
      if (flag != -1) {
        this.notificationService.showToast("Some documents are not yet approved", "Warning")
        return;
      }

      selectList.forEach(async element => {
        if (element.submitDate != null && element.approveDate != null && element.attachmentsCount > 0) {
          this.publishCCN(element);
        }
      });
      if (successMessage != '') {
        this.notificationService.showToast(successMessage, "Warning");
      }
      else {
        this.notificationService.showToast("Records published successfully", "Success");
      }
      this.refreshGrid();
    }
    else {
      this.notificationService.showToast("Kindly select atleast one record", "Warning");
    }
  }

  onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = false;
      });
    }
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  public advanceSearch() {
    this.searchList = [];
    this.isSearch = !this.isSearch;
  }

  closeAdvSearch(event: any[]) {
    this.searchList = event;
    this.isSearch = false;
    if (this.searchList.length == 0) {
      this.notificationService.showToast("Search returned no results", "Warning");
    }
    else {
      this.ccnList = this.searchList;
      this.dataBinding.skip = 0;
    }
  }

  public viewTabClick(event: { tab: { textLabel: { ccnId: any; ccnRevNo: any; }; }; }) {
    this.viewData = [];
    if (this.selectedTabIndex != 0) {
      this.viewData.push({
        projectId: this.projectId,
        groupId: this.groupId,
        ccnId: event.tab.textLabel.ccnId,
        revisionNo: event.tab.textLabel.ccnRevNo
      });
    }
  }

  public closeViewTab(tab: { docId: any; }) {
    this.viewTabs.forEach((value: any, index: number) => {
      if (value.docId == tab.docId) this.viewTabs.splice(index, 1);
    });
    if (this.viewTabs.length == 0) {
      this.selectedTabIndex = 0;
      this.refreshGrid();
    }
  }

  viewCCN(data: any) {
    let index = this.viewTabs.indexOf(data);
    if (index == -1) {
      this.viewTabs.push(data);
      this.selectedTabIndex = 1;
      this.getGridData();
    }
  }

  editCCN(data: any) {
    let dialogRef = this.dialog.open(ChangeControlCreateComponent, {
      panelClass: ['mat-dialog-primary'],
      data: { ccnId: data.ccnId, ccnRevNo: data.ccnRevNo,status:data.status }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.refreshGrid();
    });
  }

  viewAttachmentClick(data: any) {
    this.dialog.open(FileListComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '70%',
      data: { projectId: this.projectId, ccnId: data.ccnId, revisionNo: data.ccnRevNo, libraryName: FileUploadLibrary.CCNDocuments, createdBy: this.memberId, isDeleteEnable: data.publishDate == null, documentNo: data.ccnNo },
    });
  }

  printCCN(data: any) {
    let dialogRef = this.dialog.open(CcnPrintComponent, {
      panelClass: ['mat-dialog-primary'],
      data: { ccnId: data.ccnId, ccnRevNo: data.ccnRevNo, discCode: data.discCode }
    });
  }
}
